/*
 * @Author: libo 
 * @Date: 2020-11-19 10:58:20 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-06-20 19:02:15
 */

<template>
    <a-modal
        :width="modalWidth"
        :visible="visible"
        :title="title"
        destroyOnClose
        :confirmLoading="confirmLoading"
        @cancel="handleCancel"
                :cancelText="$t('关闭')"
        wrapClassName="ant-modal-cust-warp"
        >
        <template slot="footer">
            <a-button @click="handleCancel">{{ $t('关闭') }}</a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <a-tabs v-model="activeKey" @change="changeTab">
                <a-tab-pane key="1" :tab="$t('数据详情')">
                    <detail-list :col="2" v-if="!!model.idList">
                        <a-textarea v-model="model.meterIdList" placeholder="..." :rows="3" style="width:100%;" disabled />
                    </detail-list>
                    <detail-list :col="3" v-else>
                    <detail-list-item :term="$t('故障类型')">{{meterWarnTypeObj[model.meterWarnType]?$t(meterWarnTypeObj[model.meterWarnType]):'--'}}</detail-list-item>
                    <detail-list-item :term="$t('处理进度')">{{model.meterDealStatus == 2?$t('已处理'):model.meterDealStatus == 1?$t('处理中'):$t('未处理')}}</detail-list-item>
                    <detail-list-item :term="$t('处理时间')">{{model.meterDealTime?model.meterDealTime :'--'}}</detail-list-item>
                    <detail-list-item :term="$t('处理人')">{{model.meterDealBy?model.meterDealBy :'--'}}</detail-list-item>
                    <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                    <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
                    <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
                    <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):$t('未知')}}</detail-list-item>
                    <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
                    <detail-list-item :term="$t('用户地址')" :itemCol="1" v-if="model.userAreaName">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
                    <detail-list-item :term="$t('用户地址')" :itemCol="1" v-else>{{model.userAddr}}</detail-list-item>
                    <detail-list-item :term="$t('处理描述')" :itemCol="1">{{model.meterDealDescription3!=null?model.meterDealDescription3: model.meterDealDescription2!=null? 
              model.meterDealDescription2: model.meterDealDescription1!=null?
              model.meterDealDescription1: model.meterDealDescription0!=null? model.meterDealDescription0: ''}}</detail-list-item>
                    </detail-list>
                </a-tab-pane>
                <a-tab-pane key="2" :tab="$t('历史记录')">
                    <div class="form-contain">
                        <div class="table-page-search-wrapper">
                        <a-form layout="inline" @keyup.enter.native="searchQuery">
                            <a-row :gutter="24">
                                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('处理状态')">
                                        <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                                            <a-select-option value="0">
                                            {{ $t('未处理') }}
                                            </a-select-option>
                                            <a-select-option value="1">
                                            {{ $t('处理中') }}
                                            </a-select-option>
                                            <a-select-option value="2">
                                            {{ $t('已处理') }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    </span>
                                </a-col>
                            </a-row>
                        </a-form>
                        
                        </div>
                        <!-- 操作按钮区域 -->
                        <div class="table-operator">
                        <!--<a-button type="primary" icon="download" @click="handleExportXlsUserPayRecord('交易记录')">导出</a-button>-->
                        </div>
                        <a-table 
                            :columns="columns"
                            :data-source="dataSource"
                            :scroll="{x:true}"
                            rowKey='id'
                            size="middle"
                            :pagination="ipagination"
                            @change="handleTableChange"
                            class="j-table-force-nowrap"
                        >
                            <span slot="meterDealStatus" slot-scope="text, record">
                                <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
                                <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
                                <label v-else class="wait-status">{{ $t('未处理') }}</label>
                            </span>
                        </a-table>
                    </div>
                </a-tab-pane>

                <a-tab-pane key="3" :tab="$t('处理记录')">
                    <div class="form-contain">
                        <!-- 操作按钮区域 -->
                        <div class="table-operator">
                        <!--<a-button type="primary" icon="download" @click="handleExportXlsUserPayRecord('交易记录')">导出</a-button>-->
                        </div>
                        <a-table 
                            :columns="dealColumns"
                            :data-source="dealDataSource"
                            :scroll="{x:true}"
                            rowKey='id'
                            size="middle"
                            :pagination="dealIpagination"
                            @change="handleDealTableChange"
                            class="j-table-force-nowrap"
                        >
                        </a-table>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </a-spin>
    </a-modal>
</template>
<script>
  import { httpAction,getAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj,meterWarnTypeObj} from '@/utils/constants/commonConstant'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {isUndefined,isEmptyObject} from'@/utils/validate'
  
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterReadingAbnormalLastDetailModal',
    components: {
      DetailList,
      DetailListItem
    },
    mixins:[JeecgListMixin],
    data () {
      return {
        title:'',
        modalWidth:900,
        Mn100FkStatusObj,
        visible: false,
        confirmLoading: false,
        model: {},
        formModel: {},
        rules:{
        },
        url: {
          add: "/jeecg-charge/meter/meterUpDataFaultLastRecord/add",
          doWarnTask: "jeecg-charge/meter/meterUpDataFaultLastRecord/doWarnTask",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          list: "/jeecg-charge/meter/meterUpDataFaultRecord/list",
          dealList: "/jeecg-charge/meter/meterUpDataFaultDealRecord/list"
        },
        meterTypeObj,
        meterWarnTypeObj,
        disableMixinCreated: true,
        activeKey: '1',
        uniqueParam: {},
        dealDataSource: [],
        /* 分页参数 */
        dealIpagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        /* 排序参数 */
        dealIsorter:{
          column: 'meterDealTime',
          order: 'desc',
        },
      }
    },
    computed:{
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'meterType',
            width:100,
            ellipsis: true,
            customRender: (t,r,index) => {
              let data = meterTypeObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            },
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('故障类型'),
            align:"center",
            dataIndex: 'meterWarnType',
            width:150,
            ellipsis: true,
            customRender: (t,r,index) => {
              let data = meterWarnTypeObj
              if(isUndefined(data[t])) {
                return this.$t('其他')
              }
              return this.$t(data[t])
            },
          },
          {
            title: this.$t('告警时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'meterDealTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('处理描述'),
            align:"center",
            dataIndex: 'meterDealDescription',
            width:150,
            ellipsis: true,
            customRender: (t,r,index) => {
              return r.meterDealDescription3!=null?r.meterDealDescription3: r.meterDealDescription2!=null?
              r.meterDealDescription2: r.meterDealDescription1!=null?
              r.meterDealDescription1: r.meterDealDescription0!=null? r.meterDealDescription0: ''
            }
          }
        ]
      },
      dealColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('本轮告警起始时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('本轮告警结束时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'meterDealTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('处理人'),
            align:"center",
            dataIndex: 'meterDealBy',
            width:150,
            ellipsis: true
          }
        ]
      },
    },
    methods: {
      edit(record) {
          this.activeKey  = '1';
        this.visible = true;
        this.model = Object.assign({}, record)
        console.log(this.model);
        this.uniqueParam.meterId = this.model.meterId;
        this.uniqueParam.meterWarnType = this.model.meterWarnType;
        
      },
      handleSubmit () {
        
      },
      handleCancel() {
        this.close();
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      searchReset() { //重置
        this.formModel = {}
      },
      changeTab() {
          if(this.activeKey == 2) {
              this.loadData(1)
          }else if(this.activeKey == 3) {
            this.loadDealData(2)
          }
      },
      loadDealData(arg) {
        if(!this.url.dealList){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.dealIpagination.current = 1;
        }
        let params = {};//查询条件
        params = Object.assign(params, this.queryParam, this.dealIsorter ,this.filters);
        params.meterId = this.model.meterId;
        this.loading = true;
        getAction(this.url.dealList, params).then((res) => {
          if (res.success) {
            this.dealDataSource = res.result.records;
            this.dealIpagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      handleDealTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.dealIsorter.column = sorter.field;
          this.dealIsorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.dealIpagination = pagination;
        this.loadDealData();
      },
    }
  }
</script>

<style scoped>
.ant-row{
  margin-top: 8px;
}
.ant-form-item{
  margin-bottom: 8px;
}
.detail-list >>> .content{
  line-height: normal;
}
</style>